import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IParRegion } from 'app/shared/model/par-region.model';
import { getEntities as getParRegions } from 'app/entities/par-region/par-region.reducer';
import { getEntity, updateEntity, createEntity, reset } from './par-city.reducer';
import { IParCity } from 'app/shared/model/par-city.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model';

export const ParCityUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const parRegions = useAppSelector(state => state.parRegion.entities);
  const parCityEntity = useAppSelector(state => state.parCity.entity);
  const loading = useAppSelector(state => state.parCity.loading);
  const updating = useAppSelector(state => state.parCity.updating);
  const updateSuccess = useAppSelector(state => state.parCity.updateSuccess);
  const statusValues = Object.keys(Status);
  const handleClose = () => {
    props.history.push('/par-city');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getParRegions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...parCityEntity,
      ...values,
      region: parRegions.find(it => it.id.toString() === values.region.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ACTIVE',
          ...parCityEntity,
          region: parCityEntity?.region?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.parCity.home.createOrEditLabel" data-cy="ParCityCreateUpdateHeading">
            <Translate contentKey="almobadaraMasterDataApp.parCity.home.createOrEditLabel">Create or edit a ParCity</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="par-city-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parCity.name')}
                id="par-city-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField label={translate('almobadaraMasterDataApp.parCity.nameAr')} id="par-city-nameAr" name="nameAr" type="text" />
              <ValidatedField label={translate('almobadaraMasterDataApp.parCity.nameEn')} id="par-city-nameEn" name="nameEn" type="text" />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parCity.status')}
                id="par-city-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {statusValues.map(status => (
                  <option value={status} key={status}>
                    {translate('almobadaraMasterDataApp.Status.' + status)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="par-city-region"
                name="region"
                data-cy="region"
                label={translate('almobadaraMasterDataApp.parCity.region')}
                type="select"
              >
                <option value="" key="0" />
                {parRegions
                  ? parRegions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/par-city" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParCityUpdate;
